<div
  class="relative mx-auto block w-full md:max-w-lg rounded-lg bg-white px-8 lg:px-14 py-8 lg:py-14 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)]">

  <button (click)="drawerService.close()"
          class="absolute top-1 right-1 inline-flex rounded-md p-1.5 text-gray-500 hover:text-bleuCaliceo-300 focus:outline-none focus:ring-1 focus:ring-bleuCaliceo-300 focus:ring-offset-2 focus:ring-offset-bleuCaliceo-100"
          type="button">
    <span class="sr-only">Dismiss</span>
    <svg aria-hidden="true" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
      <path
        d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
    </svg>
  </button>
  <!--Center title -->
  <h1 class="font-bold text-3xl md:text-4xl leading-tight text-bleuCaliceo-300 uppercase text-center">
    @if (rendezVous().waiting) {
      {{ 'cancelWait' | translate }}
    } @else {
      {{ 'cancelSession' | translate }}
    }
  </h1>
  <!-- Description -->
  <h2 class="mt-8 font-semibold text-lg leading-tight text-center">
    {{ rendezVous().label }}
  </h2>
  <span
    class="mt-4 w-full inline-block text-lg leading-tight text-center">{{ rendezVous().date | date }} {{ rendezVous().start }}
    - {{ rendezVous().end }}</span>
  @if (lessThan24h() && !rendezVous().waiting) {
    <p class="mt-4 w-full inline-block text-sm leading-tight whitespace-pre-line overflow-auto max-h-80">
      {{ 'cancelVitalityTerms' | translate }}
    </p>
  }
  <!--<span class="text-lg leading-tight">{{ seance.date | date }} {{ seance.start }} - {{ seance.end }}</span>-->

  <!--Big Button-->
  @if (rendezVous().waiting) {
    <button appHoverGradient class="big-btn" [appProgressClick]="cancelWait">
      {{ 'validate' | translate }}
    </button>
  } @else {
    <button appHoverGradient class="big-btn" [appProgressClick]="cancel">
      {{ 'validate' | translate }}
    </button>
  }
</div>
